import { IParameter } from "../types";
import { IGetParamsGET_FROM_OR_TO, IGetParamsGET_STOPPOINT_JSON_SHIPPING, IGetParamsGET_STOPS_JSON } from "./types";

function getParamsGET_STOPS_JSON({
    NFIRST_ROWNUM = 1,
    NLAST_ROWNUM = 2000000,
    CFILTER = '',
    NID = null,
    NCITY_ID,
    NCUR_LATITUDE = null,
    NCUR_LONGITUDE = null,
    NSHOW_DIRECTION = "1",
    nAREA_ID = "",
}: IGetParamsGET_STOPS_JSON): IParameter[] {
    return [
        { name: "NACCOUNT_ID", value: null },
        { name: "NFIRST_ROWNUM", value: NFIRST_ROWNUM },
        { name: "NLAST_ROWNUM", value: NLAST_ROWNUM },
        { name: "CFILTER", value: CFILTER },
        { name: "NID", value: NID },
        { name: "NCITY_ID", value: NCITY_ID },
        { name: "NCUR_LATITUDE", value: NCUR_LATITUDE },
        { name: "NCUR_LONGITUDE", value: NCUR_LONGITUDE },
        { name: "NSHOW_DIRECTION", value: NSHOW_DIRECTION },
        { name: "nAREA_ID", value: nAREA_ID }
    ];
}

function getParamsGET_STOPPOINT_JSON_SHIPPING({
    CTYPE = "TO",
    NSTOPPOINT_FROM_ID = "",
    NFIRST_ROWNUM = 1,
    NLAST_ROWNUM = 20000,
    CFILTER = "",
    CGPS_IDS = null,
    CFAV_IDS = null,
    NGPS_MODE = null,
    NFAV_MODE = null,
    NLOCALITY_ID,
    NLOCALITY_ID_TO = '',
    NMESSAGE_TYPE = "-1",
}: IGetParamsGET_STOPPOINT_JSON_SHIPPING): { name: string; value: string | number }[] {
    return [
        { name: "CTYPE", value: CTYPE },
        { name: "NSTOPPOINT_FROM_ID", value: NSTOPPOINT_FROM_ID },
        { name: "NFIRST_ROWNUM", value: NFIRST_ROWNUM },
        { name: "NLAST_ROWNUM", value: NLAST_ROWNUM },
        { name: "CFILTER", value: CFILTER },
        { name: "CGPS_IDS", value: CGPS_IDS },
        { name: "CFAV_IDS", value: CFAV_IDS },
        { name: "NGPS_MODE", value: NGPS_MODE },
        { name: "NFAV_MODE", value: NFAV_MODE },
        { name: "NLOCALITY_ID", value: NLOCALITY_ID },
        { name: "NLOCALITY_ID_TO", value: NLOCALITY_ID_TO },
        { name: "NMESSAGE_TYPE", value: NMESSAGE_TYPE }
    ];
}

function getParamsGET_FROM_OR_TO({
    CWHAT,
    NLOCALITY_ID_FROM = "",
    NLOCALITY_ID_TO = "",
    NSTOPPOINT_ID_FROM = "",
    NSTOPPOINT_ID_TO = "",
    NFIRST_ROWNUM = 1,
    NLAST_ROWNUM = 1000,
    CFILTER = "",
}: IGetParamsGET_FROM_OR_TO): { name: string; value: string | number }[] {
    return [
        { name: "CWHAT", value: CWHAT },
        { name: "NLOCALITY_ID_FROM", value: NLOCALITY_ID_FROM },
        { name: "NLOCALITY_ID_TO", value: NLOCALITY_ID_TO },
        { name: "NSTOPPOINT_ID_FROM", value: NSTOPPOINT_ID_FROM },
        { name: "NSTOPPOINT_ID_TO", value: NSTOPPOINT_ID_TO },
        { name: "NFIRST_ROWNUM", value: NFIRST_ROWNUM },
        { name: "NLAST_ROWNUM", value: NLAST_ROWNUM },
        { name: "CFILTER", value: CFILTER },
    ];
}

// const initParamsGET_STOPS_JSON = {
//     NFIRST_ROWNUM : 1,
//     NLAST_ROWNUM : 2000000,
//     CFILTER : '',
//     NID : null,
//     NCITY_ID,
//     NCUR_LATITUDE : null,
//     NCUR_LONGITUDE : null,
//     NSHOW_DIRECTION : "1",
// }

export {
    getParamsGET_STOPS_JSON,
    getParamsGET_STOPPOINT_JSON_SHIPPING,
    getParamsGET_FROM_OR_TO,
};